import { POST } from "../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchSODConflicts = (fetchSODConflictsBody: {}) =>
  POST("sod/check", fetchSODConflictsBody).pipe(
    map((response: any) => response)
  );

export const fetchSODConflictsBR = (fetchSODConflictsBody: {}) =>
  POST("sod/checkBR", fetchSODConflictsBody).pipe(
    map((response: any) => response)
  );
